const PlaceholderPostVertical = () => {
    return (
        <div className="item">
            {Array.from({ length: 3}).map((_,index) => (
                <div key={index} className="placeholder bg-white"style={{
                    width: "100%",
                    margin: "20px",
                    textAlign: "center"
                }}>
                    <div className="card">
                        <div className="row g-0">
                            <div className="col-md-4">
                                <div className="placeholder-image" style={{ height: '250px', backgroundColor: '#e0e0e0' }}></div>
                            </div>
                            <div className="col-md-8 d-flex flex-column gap-4 p-3">
                                <div className="placeholder-title" style={{ height: '30px', width: '60%', backgroundColor: '#e0e0e0' }}></div>
                                <div className="placeholder-text" style={{ height: '40px', width: '80%', backgroundColor: '#e0e0e0' }}></div>
                                <div className="placeholder-title" style={{ height: '30px', width: '60%', backgroundColor: '#e0e0e0' }}></div>
                                <div className="placeholder-button" style={{ height: '30px', width: '120px', backgroundColor: '#e0e0e0' }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PlaceholderPostVertical;
